// extracted by mini-css-extract-plugin
module.exports = {"SkChase":"Spinner_SkChase__1bP-l","SkChaseDot":"Spinner_SkChaseDot__1R5bK","SkChaseDot-before":"Spinner_SkChaseDot-before__1-R7j"};